import { render, staticRenderFns } from "./CalendarStadiumEvent.vue?vue&type=template&id=78511b38&"
import script from "./CalendarStadiumEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarStadiumEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports